export const payConfig = {
  pay_link: "https://pay.figai.ir/",

  ref: {
    default_ref: "ref",
    traking_refs: ['ref', 'utm_campaign'],
    static_refs: {
      utm_source: "landing",
      utm_medium: "website_button",
    },
  },
};

export type PayConfig = typeof payConfig;
